import React from 'react';
import { Link } from 'react-router-dom';
import MkBadge from './MkBadge';
import { kmoPlayHref } from '../../marketing/links';
import { mkTrack } from '../../marketing/track';

/**
 * Keep Me Out is Android-only: only ever a Google Play badge — never an App Store link. iPhone
 * visitors get the Android-only note pointing at Bring Me Back instead (spec §4.2).
 */
const KmoCta = ({ placement, platform, showMeta = true, className }) => {
  if (platform === 'ios') {
    return (
      <p className={['mk-platform-note', className].filter(Boolean).join(' ')}>
        Keep Me Out is Android-only.{' '}
        <Link to="/bring-me-back" onClick={() => mkTrack('cta_click', `bmb_page:${placement}`)}>
          On iPhone, try Bring Me Back →
        </Link>
      </p>
    );
  }
  return (
    <div className={['mk-cta', className].filter(Boolean).join(' ')}>
      <div className="mk-badges">
        <MkBadge
          store="play"
          href={kmoPlayHref(placement)}
          alt="Get Keep Me Out on Google Play"
          onClick={() => mkTrack('store_click', `kmo:play:${placement}`)}
        />
      </div>
      {showMeta && <p className="mk-micro mk-cta__meta">Free to download · Android 6.0 and up</p>}
    </div>
  );
};

export default KmoCta;
